module.exports = "/assets/images/help_826213.svg";